<div id="app-sidebar-2" class="h-screen flex-shrink-0 fixed left-0 top-0 z-5 select-none border-right-1 surface-border"
  [ngClass]="{
        'h-screen flex-shrink-0 z-5 select-none bg-white': true,
    'fixed left-0 top-0': true,
    'hidden lg:block lg:static': !sidebarVisible,

    'block': sidebarVisible
  }" style="width: 280px">
  <div class="flex flex-column h-full">
    <div class="flex align-items-center mt-2 justify-content-left px-4 flex-shrink-0" style="height: 60px">
      <img src="assets/images/app_logo.png" alt="Image" height="30" />
      <p-tag *ngIf="showStagingBanner" value="Staging" severity="warning" styleClass="ml-3"></p-tag>
    </div>

    <!-- Current Organisation Name Display -->
    <a *ngIf="currentOrganisationName && me" #switchOrgBtn (click)="orgOverlay.toggle($event)"
      class="mx-3 mt-3 p-3 flex align-items-center border-round cursor-pointer font-medium text-base font-bold shadow-2 transition-duration-150 transition-colors current-org-display"
      style="outline: none; user-select: none">
      <i class="material-icons mr-2">business</i>
      <div class="flex flex-column">
        <span class="font-medium">{{ currentOrganisationName }}</span>
        <div class="flex align-items-center text-xs opacity-80">
          <i class="material-icons" style="font-size: 14px; margin-right: 4px;">swap_horiz</i>
          <span>Switch org</span>
        </div>
      </div>
      <p-overlayPanel #orgOverlay [dismissable]="true" [style]="{ minWidth: '220px' }" [baseZIndex]="1000">
        <div *ngFor="let org of allOrgs; let last = last" (click)="onOrgSelected(org.id); orgOverlay.hide()"
          class="flex align-items-center p-2 border-round mb-2 org-option" [ngClass]="{
            'selected-org':
              org.id === me.currentOrganisationId,
            'border-1 cursor-pointer shadow-2':
              org.id !== me.currentOrganisationId
          }" style="
            transition: background 0.2s, box-shadow 0.2s, border 0.2s;
            min-height: 44px;
          ">
          <i class="material-icons mr-2">business</i>
          <i class="material-icons mr-2" *ngIf="org.id === me?.currentOrganisationId">check_circle</i>
          <span>{{
            org.displayName || org.legalName
            }}</span>
        </div>
      </p-overlayPanel>
    </a>
    <div class="overflow-y-auto mt-3">
      <hr class="my-4 mx-3">

      <!--sysadmin controls -->
      <a *ngIf="showAdminItems" pRipple
        class="mx-3 mt-3 p-3 2 flex align-items-center border-round cursor-pointer transition-duration-150 transition-colors"
        pStyleClass="@next" enterClass="hidden" enterActiveClass="slidedown" leaveToClass="hidden"
        leaveActiveClass="slideup">
        <i class="material-icons mr-2">admin_panel_settings</i>
        <span class="font-medium">{{ 'SYSTEM_ADMIN' | translate }}</span>
        <i class="material-icons ml-auto">expand_more</i>
      </a>
      <ul *ngIf="showAdminItems"
        class="list-none pl-5 pr-3 m-0 hidden origin-top animation-duration-150 overflow-hidden animation-ease-in-out">
        <li class="mx-3">
          <p-button [routerLink]="'/admin/machines'" routerLinkActive="sidebar-active" [text]="true" [plain]="true"
            styleClass="flex align-items-center justify-content-start cursor-pointer p-3 border-round transition-duration-150 transition-colors w-full">
            <i class="material-icons mr-2">conveyor_belt</i>
            <span class="font-medium">{{ 'MACHINES' | translate }}</span>
          </p-button>
        </li>
        <li class="mx-3">
          <p-button [routerLink]="'/admin/recordings'" routerLinkActive="sidebar-active" [text]="true" [plain]="true"
            styleClass="flex align-items-center justify-content-start cursor-pointer p-3 border-round transition-duration-150 transition-colors w-full">
            <i class="material-icons mr-2">center_focus_weak</i>
            <span class="font-medium">{{ 'RECORDINGS' | translate }}</span>
          </p-button>
        </li>
        <li>
        </li>
      </ul>

      <!-- org admin controls -->
      <ul class="list-none pl-3 pr-3 pb-3 pt-1 m-0">
        <li class="mx-3 mb-2">
          <p-button [routerLink]="'orgs/' + me?.currentOrganisationId + '/patients/manage'"
            routerLinkActive="sidebar-active" [text]="true" [plain]="true"
            styleClass="flex align-items-center justify-content-start cursor-pointer p-3 border-round transition-duration-150 transition-colors w-full">
            <i class="material-icons mr-2">groups</i>
            <span class="font-medium">Patients</span>
          </p-button>
        </li>

        <!--li class="mx-3 mb-2">
          <p-button [routerLink]="'orgs/' + me?.currentOrganisationId + '/forms/manage'"
            routerLinkActive="sidebar-active" [text]="true" [plain]="true"
            styleClass="flex align-items-center justify-content-start cursor-pointer p-3 border-round transition-duration-150 transition-colors w-full">
            <i class="material-icons mr-2">library_books</i>
            <span class="font-medium">Form Library</span>
          </p-button>
        </li>
        <li class="mx-3 mb-2">
          <p-button [routerLink]="'orgs/' + me?.currentOrganisationId + '/form-assignments'"
            routerLinkActive="sidebar-active" [text]="true" [plain]="true"
            styleClass="flex align-items-center justify-content-start cursor-pointer p-3 border-round transition-duration-150 transition-colors w-full">
            <i class="material-icons mr-2">description</i>
            <span class="font-medium">Patient Forms</span>
          </p-button>
        </li-->

        <li class="mx-3">
          <p-button [routerLink]="'orgs/' + me?.currentOrganisationId + '/manage'" routerLinkActive="sidebar-active"
            [text]="true" [plain]="true"
            styleClass="flex align-items-center justify-content-start cursor-pointer p-3 border-round transition-duration-150 transition-colors w-full">
            <i class="material-icons mr-2">settings</i>
            <span class="font-medium">{{ 'MANAGE' | translate }} Org</span>
          </p-button>
        </li>
      </ul>
    </div>
    <div class="mt-auto profile-section" *ngIf="me">
      <hr class="my-4 mx-3">
      <ul class="list-none p-2 m-0 hidden origin-bottom animation-duration-150 overflow-hidden animation-ease-in-out">
        <li class="mx-3">
          <p-button [routerLink]="'me'" routerLinkActive="sidebar-active" [text]="true" [plain]="true"
            styleClass="flex align-items-center justify-content-start cursor-pointer p-3 border-round transition-duration-150 transition-colors w-full">
            <i class="material-icons mr-2">person</i>
            <span class="font-medium">{{ 'PROFILE' | translate }}</span>
          </p-button>
        </li>
        <li class="mx-3">
          <p-button (onClick)="signoutPressed()" [text]="true" [plain]="true"
            styleClass="flex align-items-center justify-content-start cursor-pointer p-3 border-round transition-duration-150 transition-colors w-full">
            <i class="material-icons mr-2">logout</i>
            <span class="font-medium">{{ 'SIGN_OUT' | translate }}</span>
          </p-button>
        </li>
      </ul>

      <a pRipple
        class="m-3 px-3 py-2 flex align-items-center border-round cursor-pointer transition-duration-150 transition-colors"
        pStyleClass="@prev" enterClass="hidden" enterActiveClass="slidedown" leaveToClass="hidden"
        leaveActiveClass="slideup">
        <div class="flex flex-column flex-1 min-w-0">
          <div class="flex align-items-center">
            <span class="font-medium">{{ me.firstName | titlecase }} {{ me.lastName | titlecase }}</span>
            <i class="material-icons ml-2 text-sm">person</i>
          </div>
          <span class="text-sm text-600" style="word-break: break-word; white-space: normal;">{{ me.email }}</span>
        </div>
        <i class="material-icons ml-auto">expand_less</i>
      </a>
    </div>

    <!-- Version Number -->
    <div class="mx-3 mb-3 text-center">
      <app-global-version-number></app-global-version-number>
    </div>
  </div>
</div>

<!-- Hamburger menu for small screens -->
<button
  class="block lg:hidden fixed top-3 left-3 z-5 p-2 rounded shadow-lg focus:outline-none border-none hamburger-menu"
  (click)="sidebarVisible = !sidebarVisible" aria-label="Toggle sidebar">
  <i class="material-icons">menu</i>
</button>

<!-- Sidebar overlay for small screens -->
<div *ngIf="sidebarVisible" class="fixed inset-0 z-4 bg-black-alpha-70 lg:hidden" (click)="sidebarVisible = false">
</div>